// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Future from "./Future.bs.mjs";

function fromPromise(promise) {
  return Future.makePure(function (resolve) {
              promise.then((function (ok) {
                      resolve({
                            TAG: "Ok",
                            _0: ok
                          });
                    }), (function (error) {
                      resolve({
                            TAG: "Error",
                            _0: error
                          });
                    }));
            });
}

function toPromise(future) {
  return new Promise((function (resolve, param) {
                Future.get(future, (function (value) {
                        resolve(value);
                      }));
              }));
}

function resultToPromise(future) {
  return new Promise((function (resolve, reject) {
                Future.get(future, (function (value) {
                        if (value.TAG === "Ok") {
                          return resolve(value._0);
                        } else {
                          return reject(value._0);
                        }
                      }));
              }));
}

export {
  fromPromise ,
  toPromise ,
  resultToPromise ,
}
/* No side effect */
